export const selectContextId = (state) => state.app.contextId;



// WEBPACK FOOTER //
// ./src/routes/Templates/common/modules/templateForm.selectors.js